/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CvProcessingStatisticsResponseDto } from '../models';
/**
 * StatisticsRestApi - axios parameter creator
 */
export const StatisticsRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve CV processing statistics with filtering by date range, process and recruiter
         * @summary Get CV processing statistics
         * @param {string} [monthFrom] Start month in format YYYY-MM
         * @param {string} [monthTo] End month in format YYYY-MM
         * @param {Array<string>} [recruiterIds] Filter by recruiter IDs
         * @param {Array<string>} [processIds] Filter by process IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvProcessingStatistics: async (monthFrom?: string, monthTo?: string, recruiterIds?: Array<string>, processIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/statistics/cv-processing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (monthFrom !== undefined) {
                localVarQueryParameter['monthFrom'] = monthFrom;
            }

            if (monthTo !== undefined) {
                localVarQueryParameter['monthTo'] = monthTo;
            }

            if (recruiterIds) {
                localVarQueryParameter['recruiterIds'] = recruiterIds.join(COLLECTION_FORMATS.csv);
            }

            if (processIds) {
                localVarQueryParameter['processIds'] = processIds.join(COLLECTION_FORMATS.csv);
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsRestApi - functional programming interface
 */
export const StatisticsRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve CV processing statistics with filtering by date range, process and recruiter
         * @summary Get CV processing statistics
         * @param {string} [monthFrom] Start month in format YYYY-MM
         * @param {string} [monthTo] End month in format YYYY-MM
         * @param {Array<string>} [recruiterIds] Filter by recruiter IDs
         * @param {Array<string>} [processIds] Filter by process IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvProcessingStatistics(monthFrom?: string, monthTo?: string, recruiterIds?: Array<string>, processIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvProcessingStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvProcessingStatistics(monthFrom, monthTo, recruiterIds, processIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsRestApi.getCvProcessingStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsRestApi - factory interface
 */
export const StatisticsRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsRestApiFp(configuration)
    return {
        /**
         * Retrieve CV processing statistics with filtering by date range, process and recruiter
         * @summary Get CV processing statistics
         * @param {string} [monthFrom] Start month in format YYYY-MM
         * @param {string} [monthTo] End month in format YYYY-MM
         * @param {Array<string>} [recruiterIds] Filter by recruiter IDs
         * @param {Array<string>} [processIds] Filter by process IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvProcessingStatistics(monthFrom?: string, monthTo?: string, recruiterIds?: Array<string>, processIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CvProcessingStatisticsResponseDto> {
            return localVarFp.getCvProcessingStatistics(monthFrom, monthTo, recruiterIds, processIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsRestApi - interface
 */
export interface StatisticsRestApiInterface {
    /**
     * Retrieve CV processing statistics with filtering by date range, process and recruiter
     * @summary Get CV processing statistics
     * @param {string} [monthFrom] Start month in format YYYY-MM
     * @param {string} [monthTo] End month in format YYYY-MM
     * @param {Array<string>} [recruiterIds] Filter by recruiter IDs
     * @param {Array<string>} [processIds] Filter by process IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvProcessingStatistics(monthFrom?: string, monthTo?: string, recruiterIds?: Array<string>, processIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CvProcessingStatisticsResponseDto>;

}

/**
 * StatisticsRestApi - object-oriented interface
 */
export class StatisticsRestApi extends BaseAPI implements StatisticsRestApiInterface {
    /**
     * Retrieve CV processing statistics with filtering by date range, process and recruiter
     * @summary Get CV processing statistics
     * @param {string} [monthFrom] Start month in format YYYY-MM
     * @param {string} [monthTo] End month in format YYYY-MM
     * @param {Array<string>} [recruiterIds] Filter by recruiter IDs
     * @param {Array<string>} [processIds] Filter by process IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvProcessingStatistics(monthFrom?: string, monthTo?: string, recruiterIds?: Array<string>, processIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return StatisticsRestApiFp(this.configuration).getCvProcessingStatistics(monthFrom, monthTo, recruiterIds, processIds, options).then((request) => request(this.axios, this.basePath));
    }
}

